var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1654 56.875V51.4583C54.1654 48.5852 53.024 45.8297 50.9924 43.798C48.9607 41.7664 46.2052 40.625 43.332 40.625H21.6654C18.7922 40.625 16.0367 41.7664 14.005 43.798C11.9734 45.8297 10.832 48.5852 10.832 51.4583V56.875M43.332 18.9583C43.332 24.9414 38.4818 29.7917 32.4987 29.7917C26.5156 29.7917 21.6654 24.9414 21.6654 18.9583C21.6654 12.9752 26.5156 8.125 32.4987 8.125C38.4818 8.125 43.332 12.9752 43.332 18.9583Z",
    stroke: "#F5F5F5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBg);
export default __webpack_public_path__ + "static/media/UserBG.6e7b3bb326dcd481be454d88be4043b0.svg";
export { ForwardRef as ReactComponent };